import { useTranslation } from "react-i18next";
import { DropdownButton } from "react-bootstrap";

const DimensionFilter = ({ assetDimensionFilter, setAssetDimensionFilter }) => {
  const { t } = useTranslation(["advertising"]);

  const dimensionOptions = [
    {
      id: 0,
      label: t(($) => $.advertising["All"]),
      value: null,
    },
    {
      id: 1,
      label: t(($) => $.advertising["{value}px or more"], { value: 400 }),
      value: 400,
    },
    {
      id: 2,
      label: t(($) => $.advertising["{value}px or more"], { value: 1500 }),
      value: 1500,
    },
    {
      id: 3,
      label: t(($) => $.advertising["{value}px or more"], { value: 3000 }),
      value: 3000,
    },
  ];

  return (
    <DropdownButton
      id="DimensionSelector"
      title={
        <span>
          <span>{assetDimensionFilter.width ? `${assetDimensionFilter.width}+` : t(($) => $.advertising["All"])}</span>
          {assetDimensionFilter.height ?
            <span> &#215; {assetDimensionFilter.height}+</span>
          : !assetDimensionFilter.width ?
            null
          : <span> &#215; {t(($) => $.advertising["All"])}</span>}
        </span>
      }
      bsPrefix="col-selector"
    >
      <div key={"all-dimensions"} role="menuitem" className="py-1">
        <label
          style={{
            marginLeft: "1rem",
            marginTop: "0.5rem",
            fontWeight: "normal",
            display: "flex",
            whiteSpace: "nowrap",
          }}
        >
          <input
            type="checkbox"
            style={{ height: "unset", marginRight: "1rem" }}
            value={null}
            onChange={(e) => {
              e.stopPropagation();
              setAssetDimensionFilter(() => ({
                width: null,
                height: null,
              }));
            }}
            checked={!assetDimensionFilter?.width && !assetDimensionFilter?.height}
          />
          {t(($) => $.advertising["All Dimensions"])}
        </label>
      </div>
      <div>{t(($) => $.advertising["Width"])}</div>
      {dimensionOptions.map(({ id, label, value }) => (
        <div key={id} role="menuitem" className="py-1">
          <label
            style={{
              marginLeft: "1rem",
              marginTop: "0.5rem",
              fontWeight: "normal",
              display: "flex",
              whiteSpace: "nowrap",
            }}
          >
            <input
              type="checkbox"
              style={{ height: "unset", marginRight: "1rem" }}
              value={value}
              onChange={(e) => {
                e.stopPropagation();

                const { value } = e.target;
                if (value === assetDimensionFilter.width) {
                  setAssetDimensionFilter((prev) => ({
                    ...prev,
                    width: null,
                  }));
                } else {
                  setAssetDimensionFilter((prev) => ({
                    ...prev,
                    width: value,
                  }));
                }
              }}
              checked={value?.toString() === assetDimensionFilter.width?.toString()}
            />
            {label}
          </label>
        </div>
      ))}
      <div>{t(($) => $.advertising["Height"])}</div>
      {dimensionOptions.map(({ id, label, value }) => (
        <div key={id} role="menuitem" className="py-1">
          <label
            style={{
              marginLeft: "1rem",
              marginTop: "0.5rem",
              fontWeight: "normal",
              display: "flex",
              whiteSpace: "nowrap",
            }}
          >
            <input
              type="checkbox"
              style={{ height: "unset", marginRight: "1rem" }}
              value={value}
              onChange={(e) => {
                e.stopPropagation();
                const { value } = e.target;

                if (value === assetDimensionFilter.height) {
                  setAssetDimensionFilter((prev) => ({
                    ...prev,
                    height: null,
                  }));
                } else {
                  setAssetDimensionFilter((prev) => ({
                    ...prev,
                    height: value,
                  }));
                }
              }}
              checked={value?.toString() === assetDimensionFilter.height?.toString()}
            />
            {label}
          </label>
        </div>
      ))}
    </DropdownButton>
  );
};

export default DimensionFilter;
